export default __webpack_public_path__ + "img/c6e37694113efa58c72f1d86cc0d32b3.svg";